import createStyles from "@material-ui/core/styles/createStyles";
import makeStyles from "@material-ui/core/styles/makeStyles";

export const useStyles = makeStyles((theme) => {
  return createStyles({
    root: {
      width: "100%",
      maxWidth: theme.spacing(3),
      background: theme.palette.primary.main,
      borderRadius: theme.shape.borderRadius
    }
  });
});
